import type { UserFilesRAGRequest } from '@/agent/chat_form/store/schemas'

type LegacyFileCutoverInput = {
  newFilesUxEnabled: boolean
  userFilesRag: UserFilesRAGRequest | null | undefined
  filePaths: string[]
  templatePaths: string[]
}

export function shouldClearLegacyFileSelectionsForNewFilesUx({ newFilesUxEnabled, userFilesRag, filePaths, templatePaths }: LegacyFileCutoverInput): boolean {
  return newFilesUxEnabled && !userFilesRag && (filePaths.length > 0 || templatePaths.length > 0)
}
